import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/userSlice";
import videoReducer from "./slices/videoUploadFetchSlice";
import courseReducer from "./slices/courseSlice";
import studentReducer from "./slices/studentSlice";
import courseVideoReducer from "./slices/purchaseSlice";
import reviewReducer from "./slices/reviewSlice";
import expertsReducer from "./slices/Expert";
import partnerReducer from "./slices/partnerSlice";
import strategyReducer from "./slices/StrategySlice";
import webinarReducer from "./slices/Webinar";
import livechat from "./slices/liveChatSlice";
import withdrawalReducer from "../redux/WithdralSlice/withdrawalSlice";
// caller
import leadReducer from "./callerSlice/leadsSlice";
import dealsReducer from "./callerSlice/dealsSlice";

const store = configureStore({
  reducer: {
    user: userReducer,
    video: videoReducer,
    course: courseReducer,
    student: studentReducer,
    purchase: courseVideoReducer,
    review: reviewReducer,
    fetchExperts: expertsReducer,
    partner: partnerReducer,
    strategy: strategyReducer,
    webinar: webinarReducer,
    livechat: livechat,
    withdrawals: withdrawalReducer,
    // caller
    leads: leadReducer,
    deals: dealsReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});

export default store;
